import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../app.config';
import { getAuthToken } from '../auth.interceptor';
import { CORRELATION_ID } from '../tracking/tracking-tokens';

@Injectable({ providedIn: 'root' })
export class EditContactService {
    constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: AppConfig) {}

    editContact(
        policyNumber: string,
        effectiveDate: string,
        phone: string,
        email: string,
        quoteId: string,
        ownership: string,
        correlationId?: string
    ): Observable<any> {
        const contactBody: Record<string, string | null> = {
            policyNumber,
            effectiveDate,
            emailId: email || '',
            phoneNumber: phone || '',
            quoteId,
            ownership: ownership,
            sourceSystem: "Policy360"
        };

        const payload = {
            oktaToken: getAuthToken(),
            action: 'updateContactPreferencesToDC',
            policyNumber,
            body: contactBody,
        };

        // Stamp the correlation id (when supplied) so the logging interceptor
        // links this api_call to the originating user action.
        const context = correlationId
            ? new HttpContext().set(CORRELATION_ID, correlationId)
            : undefined;

        return this.http.post(this.config.updateContact, payload, {
            headers: new HttpHeaders({
                'x-api-key': this.config.updateContactApiKey,
                'X-Skip-Error-Toast': 'true',
            }),
            ...(context ? { context } : {}),
        });
    }
}
